module.exports = __webpack_public_path__ + "img/code1_act.28472cfc.png";